import { Link } from "expo-router";
import { Text, View } from "react-native";

import { PageShell, SectionIntro } from "../src/components/layout";
import { Button } from "../src/components/ui";
import { palette } from "../src/theme/tokens";

export default function NotFoundScreen() {
  return (
    <PageShell>
      <SectionIntro
        eyebrow="Not Found"
        title="This route has gone quiet."
        description="The page you asked for is not part of the current WeHonor experience."
      />
      <View style={{ marginTop: 18 }}>
        <Link href="/" asChild>
          <Button label="Return Home" />
        </Link>
      </View>
      <Text
        style={{
          marginTop: 12,
          color: palette.inkSoft,
          fontFamily: "Manrope_400Regular",
          fontSize: 14,
        }}
      >
        Try the public memorial, registry, or live check-in routes from the navigation above.
      </Text>
    </PageShell>
  );
}
